type FieldError = { code?: string; params?: Record<string, string> };

const fieldErrors = (error: unknown): FieldError[] => {
  const data = (error as { data?: { fieldErrors?: FieldError[] } })?.data;
  return Array.isArray(data?.fieldErrors) ? data.fieldErrors : [];
};

export const hasFieldError = (error: unknown, code: string): boolean =>
  fieldErrors(error).some((fieldError) => fieldError.code === code);

export const takenByName = (error: unknown): string | null =>
  fieldErrors(error).find((fieldError) => fieldError.code === "zz_FieldErrorCode_NeedAlreadyTaken")?.params?.name ??
  null;
